<template>
<div>
    <div v-if="!isMobile">
        
        <div class="div_001">
            <div class="div_001_001">
                <div @click="nav_001('')"></div>
                <div>
                    <div @click="nav_001('Features')">     Features     </div>
                    <div @click="nav_001('Applications')"> Applications </div>
                    <div @click="nav_001('Projects')">     Projects     </div>
                    <div @click="nav_001('About')">        About Us     </div>
                    <div @click="nav_001('Contact')">      Contact Us   </div>
                </div>
                <div>
                    <div></div> <div> EN </div>
                </div>
            </div>
        </div>
        
        <div class="div_002">
            <div class="div_002_001">
                <div @click="nav_001('')"></div> <div><div><div></div></div></div> <div> Features </div>
            </div>
        </div>
        
        <div class="div_003" :style="{ 'height' : screenHeight - 168 + 'px' }">
            <div class="div_003_001">
                <div :style="{ 'height' : screenHeight - 200 + 'px' }">
                    <div class="div_003_001_l">
                        <div></div> <span>Learn more</span>
                    </div>
                    <div class="div_003_001_r">
                        <div>
                            <div> Hard </div> <div> | </div> <div> Fire-Resistant </div> <div> | </div> <div> Water-Resistant </div> <div> | </div> <div> Eco-Friendly </div>
                        </div>
                        <div class="iconfont_002"> Mineral Fiber Inorganic Panels </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="div_004">
            <div class="div_004_001">
                <div>
                    <div class="iconfont_002"> 10 </div>
                    <div class="iconfont_002">
                        <span> Core Advantages </span>
                        <span> Breaking Technological Monopoly </span>
                    </div>
                    <div></div>
                </div>
                <div>
                    <div><div class="icon_001"></div> <span>A2 level fire resilience</span>    <span>Enhanced fire safety performance</span></div>
                    <div><div class="icon_002"></div> <span>Extreme eco-friendly</span>        <span>Grade E0 of formaldehyde emission</span></div>
                    <div><div class="icon_003"></div> <span>Waterproof & Moisture-proof</span> <span>No Expansion</span></div>
                    <div><div class="icon_004"></div> <span>Shape Stability</span>             <span>Warp Resistance</span></div>
                    <div><div class="icon_005"></div> <span>Mold & Insect-Resistance</span>    <span>Anti-corrosion</span></div>
                </div>
                <div>
                    <div><div class="icon_006"></div> <span>70% lower</span>                       <span>than the limits of Radionuclides</span></div>
                    <div><div class="icon_007"></div> <span>Noise reduction</span>                 <span>by absorption system</span></div>
                    <div><div class="icon_008"></div> <span>Strong screw holding capability</span> <span>over 1200N</span></div>
                    <div><div class="icon_009"></div> <span>Self-owned Patents</span>              <span>Break Monopoly</span></div>
                    <div><div class="icon_010"></div> <span>Customizable Dimensions</span>         <span>Made to fit project requirements</span></div>
                </div>
            </div>
        </div>
        
        <div class="div_005">
            <div class="div_005_001">
                <div class="iconfont_002">
                    Six Core Processes for a Stable and Efficient Manufacturing System
                </div>
                <div>
                    ( Click the step buttons to learn more )
                </div>
            </div>
            <div class="div_005_002">
                <div class="div_005_002_l">
                    <div @click="v_active = 1" :class="v_active == 1 ? 'div_005_002_l_active' : '' "> Step 1 </div>
                    <div @click="v_active = 2" :class="v_active == 2 ? 'div_005_002_l_active' : '' "> Step 2 </div>
                    <div @click="v_active = 3" :class="v_active == 3 ? 'div_005_002_l_active' : '' "> Step 3 </div>
                    <div @click="v_active = 4" :class="v_active == 4 ? 'div_005_002_l_active' : '' "> Step 4 </div>
                    <div @click="v_active = 5" :class="v_active == 5 ? 'div_005_002_l_active' : '' "> Step 5 </div>
                    <div @click="v_active = 6" :class="v_active == 6 ? 'div_005_002_l_active' : '' "> Step 6 </div>
                </div>
                <div class="div_005_002_r">
                    <div @click="v_active = 1" :class="v_active == 1 ? 'div_005_002_r_active' : '' ">
                        <div> 1 </div>
                        <div></div>
                        <div>
                            Rock and ore raw materials are melted at high temperatures (above 1450°C) into a molten state, while other metallic impurities are removed.
                        </div>
                    </div>
                    <div @click="v_active = 2" :class="v_active == 2 ? 'div_005_002_r_active' : '' ">
                        <div> 2 </div>
                        <div></div>
                        <div>
                            The molten material is processed through a centrifuge to form mineral fibers.
                        </div>
                    </div>
                    <div @click="v_active = 3" :class="v_active == 3 ? 'div_005_002_r_active' : '' ">
                        <div> 3 </div>
                        <div></div>
                        <div>
                            Phenolic resin (commonly used in aerospace and high-temperature electronic materials) is integrated to enhance fire resistance and environmental performance.
                        </div>
                    </div>
                    <div @click="v_active = 4" :class="v_active == 4 ? 'div_005_002_r_active' : '' ">
                        <div> 4 </div>
                        <div></div>
                        <div>
                            The compacted fiber board is pressed using a large high-temperature continuous flat press to form the final panel structure.
                        </div>
                    </div>
                    <div @click="v_active = 5" :class="v_active == 5 ? 'div_005_002_r_active' : '' ">
                        <div> 5 </div>
                        <div></div>
                        <div>
                            After curing, the formed panels are processed with fully automated CNC equipment for cutting, finishing, and protective treatment.
                        </div>
                    </div>
                    <div @click="v_active = 6" :class="v_active == 6 ? 'div_005_002_r_active' : '' ">
                        <div> 6 </div>
                        <div></div>
                        <div>
                            Finished products are packaged and stored through an intelligent warehousing system. After quality inspection, they are distributed to the market.
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
    
    <div v-if="isMobile">
        
        <div class="div_mobile_001">
            <div class="div_mobile_001_001">
                <div class="div_mobile_001_001_l" @click="nav_001('')"></div>
                <div class="div_mobile_001_001_r" @click="fun_002()">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
        
        <div id="div_mobile_menu" class="div_mobile_menu" :style="{ height: screenHeight + 'px', top: -screenHeight + 'px' }">
            <div @click="nav_001('Features')">     Features     </div>
            <div @click="nav_001('Applications')"> Applications </div>
            <div @click="nav_001('Projects')">     Projects     </div>
            <div @click="nav_001('About')">        About Us     </div>
            <div @click="nav_001('Contact')">      Contact Us   </div>
            <div :style="{ 'height' : screenHeight - 438 + 'px' }"  @click="fun_002()"></div>
        </div>
        
        <div class="div_mobile_002">
            <div class="div_mobile_002_001">
                <div @click="nav_001('')"></div> <div><div><div></div></div></div> <div> Features </div>
            </div>
        </div>
        
        <div class="div_mobile_003">
            <div class="div_mobile_003_001">
                <div>
                    <div class="div_mobile_003_001_l">
                        <div></div> <span>Learn more</span>
                    </div>
                    <div class="div_mobile_003_001_r">
                        <div>
                            <div> Hard </div> <div> | </div> <div> Fire-Resistant </div> <div> | </div> <div> Water-Resistant </div> <div> | </div> <div> Eco-Friendly </div>
                        </div>
                        <div class="iconfont_002"> Mineral Fiber Inorganic Panels </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="div_mobile_004">
            <div class="div_mobile_004_001">
                <div>
                    <div class="iconfont_002"> 10 </div>
                    <div class="iconfont_002">
                        <span> Core Advantages </span>
                        <span> Breaking Technological Monopoly </span>
                    </div>
                    <div></div>
                </div>
                <div>
                    <div><div class="icon_001"></div> <span>A2 level fire resilience</span>        <span>Enhanced fire safety performance</span></div>
                    <div><div class="icon_002"></div> <span>Extreme eco-friendly</span>            <span>Grade E0 of formaldehyde emission</span></div>
                    <div><div class="icon_003"></div> <span>Waterproof & Moisture-proof</span>     <span>No Expansion</span></div>
                    <div><div class="icon_004"></div> <span>Shape Stability</span>                 <span>Warp Resistance</span></div>
                    <div><div class="icon_005"></div> <span>Mold & Insect-Resistance</span>        <span>Anti-corrosion</span></div>
                    <div><div class="icon_006"></div> <span>70% lower</span>                       <span>than the limits of Radionuclides</span></div>
                </div>
                <div>
                    <div><div class="icon_007"></div> <span>Noise reduction</span>                 <span>by absorption system</span></div>
                    <div><div class="icon_008"></div> <span>Strong screw holding capability</span> <span>over 1200N</span></div>
                    <div><div class="icon_009"></div> <span>Self-owned Patents</span>              <span>Break Monopoly</span></div>
                    <div><div class="icon_010"></div> <span>Customizable Dimensions</span>         <span>Made to fit project requirements</span></div>
                </div>
            </div>
        </div>
        
        <div class="div_mobile_005">
            <div class="div_mobile_005_001">
                <div class="iconfont_002">
                    Six Core Processes for a Stable and Efficient Manufacturing System
                </div>
                <div>
                    ( Click the step buttons to learn more )
                </div>
            </div>
            <div class="div_mobile_005_002">
                <div class="div_mobile_005_002_l">
                    <div @click="v_active = 1" :class="v_active == 1 ? 'div_mobile_005_002_l_active' : '' "> Step 1 </div>
                    <div @click="v_active = 2" :class="v_active == 2 ? 'div_mobile_005_002_l_active' : '' "> Step 2 </div>
                    <div @click="v_active = 3" :class="v_active == 3 ? 'div_mobile_005_002_l_active' : '' "> Step 3 </div>
                    <div @click="v_active = 4" :class="v_active == 4 ? 'div_mobile_005_002_l_active' : '' "> Step 4 </div>
                    <div @click="v_active = 5" :class="v_active == 5 ? 'div_mobile_005_002_l_active' : '' "> Step 5 </div>
                    <div @click="v_active = 6" :class="v_active == 6 ? 'div_mobile_005_002_l_active' : '' "> Step 6 </div>
                </div>
                <div class="div_mobile_005_002_r">
                    <div @click="v_active = 1" :class="v_active == 1 ? 'div_mobile_005_002_r_active' : '' ">
                        <div> 1 </div>
                        <div></div>
                        <div>
                            Rock and ore raw materials are melted at high temperatures (above 1450°C) into a molten state, while other metallic impurities are removed.
                        </div>
                    </div>
                    <div @click="v_active = 2" :class="v_active == 2 ? 'div_mobile_005_002_r_active' : '' ">
                        <div> 2 </div>
                        <div></div>
                        <div>
                            The molten material is processed through a centrifuge to form mineral fibers.
                        </div>
                    </div>
                    <div @click="v_active = 3" :class="v_active == 3 ? 'div_mobile_005_002_r_active' : '' ">
                        <div> 3 </div>
                        <div></div>
                        <div>
                            Phenolic resin (commonly used in aerospace and high-temperature electronic materials) is integrated to enhance fire resistance and environmental performance.
                        </div>
                    </div>
                    <div @click="v_active = 4" :class="v_active == 4 ? 'div_mobile_005_002_r_active' : '' ">
                        <div> 4 </div>
                        <div></div>
                        <div>
                            The compacted fiber board is pressed using a large high-temperature continuous flat press to form the final panel structure.
                        </div>
                    </div>
                    <div @click="v_active = 5" :class="v_active == 5 ? 'div_mobile_005_002_r_active' : '' ">
                        <div> 5 </div>
                        <div></div>
                        <div>
                            After curing, the formed panels are processed with fully automated CNC equipment for cutting, finishing, and protective treatment.
                        </div>
                    </div>
                    <div @click="v_active = 6" :class="v_active == 6 ? 'div_mobile_005_002_r_active' : '' ">
                        <div> 6 </div>
                        <div></div>
                        <div>
                            Finished products are packaged and stored through an intelligent warehousing system. After quality inspection, they are distributed to the market.
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            isMobile     : false,
            screenHeight : 0,
            scrollTop    : 0,
            
            v_active     : 1
        };
    },
    created() {
        // 监听；
        window.addEventListener('resize', this.checkIsMobile);
        // window.addEventListener('scroll', this.checkScrollTop);
    },
    mounted() {
        let that = this;
        
        document.title = '';
        
        this.checkIsMobile();
        this.checkScreenHeight();
    },
    destroyed() {
        window.removeEventListener('resize', this.checkIsMobile);
        // window.removeEventListener('scroll', this.checkScrollTop);
    },
    methods: {
        // 检测移动设备；
        checkIsMobile() {
            const width = window.innerWidth || document.documentElement.clientWidth;
            let isMobile_001 = width <= 768;
            
            const userAgent = window.navigator.userAgent;
            let isMobile_002 = /iPhone|iPad|iPod|Android/i.test(userAgent);
             
            this.isMobile = isMobile_001 || isMobile_002;
            
            // console.log("移动设备判断方式一：", isMobile_001);
            // console.log("移动设备判断方式二：", isMobile_002);
        },
        // 检测屏幕高度；
        checkScreenHeight() {
            const height = window.innerHeight || document.documentElement.clientHeight;
            this.screenHeight = height;
        },
        // 事件 - 导航栏跳转；
        nav_001( param ) {
            this.$router.push( "/" + param );
        },
        // 事件 - 移动端导航栏；
        fun_002( ) {
            
            let that = this;
            
            let offset = Number(document.getElementById( 'div_mobile_menu' ).style.top.split('px')[0]);
            
            console.log(offset);
            
            if ( offset < 0 ) {
                
                var menu_move = setInterval( () => {
                    
                    let offset = Number(document.getElementById( 'div_mobile_menu' ).style.top.split('px')[0]);
                    
                    document.getElementById( 'div_mobile_menu' ).style.top = Number(offset) + 10 + 'px';
                    
                    if( document.getElementById( 'div_mobile_menu' ).style.top.split('px')[0] >= 0 ) {
                        
                        document.getElementById( 'div_mobile_menu' ).style.top = '0px';
                        
                        clearInterval( menu_move );
                    }
                    
                }, 0 );
                
            } else {
                
                var menu_move = setInterval( () => {
                    
                    let offset = Number(document.getElementById( 'div_mobile_menu' ).style.top.split('px')[0]);
                    
                    document.getElementById( 'div_mobile_menu' ).style.top = Number(offset) - 10 + 'px';
                    
                    if( document.getElementById( 'div_mobile_menu' ).style.top.split('px')[0] <= -that.screenHeight ) {
                    
                        document.getElementById( 'div_mobile_menu' ).style.top = -that.screenHeight;
                        
                        clearInterval( menu_move );
                    }
                    
                }, 0 );
                
            }
        },
    }
};
</script>

<style scoped>
/*** ************************************************* ***/

.div_001 {
    width: 100%;
    height: 88px;
    
    color: #F7F4EC;
    background-color: #151513;
    
    position: fixed;
    top: 0px;
    
    z-index: 9999999;
}

.div_001_001 {
    width: 1440px;
    height: 100%;
    
    background-color: #151513;
    
    margin: 0 auto;
    
    display : flex;
    flex-direction : row;
    justify-content : center;
    align-items : center;
    
    position: relative;
}

.div_001_001 > div:first-child {
    width: 137px;
    height: 32px;
    
    cursor: pointer;
    
    background-image : url('../assets/image_000_001.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
    
    position: absolute;
    top: 28px;
    left: 32px;
}

.div_001_001 > div:nth-child(2) {
    width: 885px;
    
    font-size: 16px;
    font-weight: 500;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_001_001 > div:nth-child(2) > div {
    cursor: pointer;
}

.div_001_001 > div:last-child {
    width: 54px;
    height: 24px;
    
    cursor: pointer;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
    
    position: absolute;
    top: 32px;
    right: 32px;
}

.div_001_001 > div:last-child > div:first-child {
    width: 20px;
    height: 20px;
    
    background-image : url('../assets/image_000_003.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
    
    position: relative;
    top: 0.5px;
}

.div_001_001 > div:last-child > div:last-child {
    font-size: 16px;
    font-weight: 500;
    
    display : flex;
    flex-direction : row;
    justify-content : center;
    align-items : center;
}

/*** ************************************************* ***/

.div_002 {
    width: 100%;
    height: 168px;
    
    color: #F7F4EC;
    background-color: #151513;
}

.div_002_001 {
    width: 1440px;
    height: 100%;
    
    margin: 0 auto;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : flex-start;
}

.div_002_001 > div:first-child {
    width: 24px;
    height: 24px;
    
    margin-top: 120px;
    margin-left: 32px;
    
    cursor: pointer;
    
    background-image : url('../assets/image_000_005.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_002_001 > div:nth-child(2) {
    width: 24px;
    height: 24px;
    
    margin-top: 120px;
    margin-left: 22px;
    
    cursor: pointer;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

.div_002_001 > div:nth-child(2) > div {
    width : 0px;
    height: 0px;
    
    border-top : 8px solid transparent;
    border-left : 8px solid #F7F4EC;
    border-right : 8px solid transparent;
    border-bottom : 8px solid transparent;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
    
    position: relative;
}

.div_002_001 > div:nth-child(2) > div > div {
    width : 0px;
    height: 0px;
    
    border-top : 5px solid transparent;
    border-left : 5px solid #151513;
    border-right : 5px solid transparent;
    border-bottom : 5px solid transparent;
    
    position: absolute;
    left: -8px;
}

.div_002_001 > div:last-child {
    width : 200px;
    height: 24px;
    
    font-size: 16px;
    
    margin-top: 120px;
    margin-left: 5px;
    
    cursor: pointer;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

/*** ************************************************* ***/

.div_003 {
    width: 100%;
    background-color: #151513;
}

.div_003_001 {
    width: 1440px;
    height: 100%;
    
    margin: 0 auto;
}

.div_003_001 > div {
    width: 1376px;
    
    margin: 0 auto;
    border-radius: 10px;
    
    background-image : url('../assets/02 Features/cover.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
    
    position: relative;
}

.div_003_001_l {
    width : 400px;
    height: 140px;
    
    color: #2F2F2F;
    font-size: 16px;
    font-weight: 500;
    
    color: #F7F4EC;
    background-color: #151513;
    
    clip-path: polygon(0 0, 0 100%, 100% 100%);
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : flex-end;
    
    position: absolute;
    bottom: 0;
    left: 0;
}

.div_003_001_l > div {
    width : 24px;
    height: 24px;
    
    cursor: pointer;
    
    background-image : url('../assets/image_000_006.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_003_001_l > span {
    margin-left: 12px;
    margin-bottom: 2.5px;
    cursor: pointer;
}

.div_003_001_r {
    width : 648px;
    height: 127px;
    
    position: absolute;
    bottom: 45px;
    right: 40px;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : flex-end;
}

.div_003_001_r > div:first-child {
    width: 433px;
    
    font-size: 16px;
    color: #F7F4EC;
    
    display : flex;
    flex-direction : row;
    justify-content : space-around;
    align-items : center;
}

.div_003_001_r > div:last-child {
    font-size: 36px;
    color: #E1B94F;
    font-weight: 600;
    
    margin-top: 38px;
}

/*** ************************************************* ***/

.div_004 {
    width: 100%;
    height: 778px;
    
    background-color: #151513;
}

.div_004_001 {
    width: 1171px;
    height: 100%;
    
    margin: 0px auto;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

.div_004_001 > div:first-child {
    width: 1171px;
    height: 104px;
    
    margin-top: 88px;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_004_001 > div:first-child > div:first-child {
    width: 104px;
    height: 104px;
    
    color: #3F3A3A;
    font-size: 48px;
    background-color: #E9B733;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
}

.div_004_001 > div:first-child > div:nth-child(2) {
    width: 963px;
    
    font-size: 36px;
    color: #F7F4EC;
    
    display : flex;
    flex-direction : column;
    justify-content : space-between;
    align-items : flex-start;
}

.div_004_001 > div:first-child > div:nth-child(2) > span {
    margin-left: 24px;
}

.div_004_001 > div:first-child > div:last-child {
    width : 0px;
    height: 0px;
    
    border-top : 52px solid #E9B733;
    border-left : 52px solid transparent;
    border-right : 52px solid #E9B733;
    border-bottom : 52px solid transparent;
}

.div_004_001 > div:nth-child(2),
.div_004_001 > div:last-child {
    width: 1171px;
    height: 205px;
    
    margin-top: 60px;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_004_001 > div:nth-child(2) > div,
.div_004_001 > div:last-child   > div {
    width: 205px;
    height: 205px;
    
    color: #151513;
    background-color: #F7F4EC;
    
    border-radius: 16px;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

.div_004_001 > div:nth-child(2) > div > div:first-child ,
.div_004_001 > div:last-child   > div > div:first-child {
    width: 60px;
    height: 68px;
    
    margin-top: 31px;
    
    cursor: pointer;
    
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.icon_001 { background-image : url('../assets/02 Features/icon_001.svg'); }
.icon_002 { background-image : url('../assets/02 Features/icon_002.svg'); }
.icon_003 { background-image : url('../assets/02 Features/icon_003.svg'); }
.icon_004 { background-image : url('../assets/02 Features/icon_004.svg'); }
.icon_005 { background-image : url('../assets/02 Features/icon_005.svg'); }
.icon_006 { background-image : url('../assets/02 Features/icon_006.svg'); }
.icon_007 { background-image : url('../assets/02 Features/icon_007.svg'); }
.icon_008 { background-image : url('../assets/02 Features/icon_008.svg'); }
.icon_009 { background-image : url('../assets/02 Features/icon_009.svg'); }
.icon_010 { background-image : url('../assets/02 Features/icon_010.svg'); }

.div_004_001 > div:nth-child(2) > div > span:nth-child(2) ,
.div_004_001 > div:last-child   > div > span:nth-child(2) {
    width: 145px;
    height: 48px;
    
    font-size: 16px;
    
    margin-top: 4px;
}

.div_004_001 > div:nth-child(2) > div:nth-child(4) > span:nth-child(2) {
    width: 90px;
}

.div_004_001 > div:last-child > div:nth-child(1) > span:nth-child(2) {
    width: 40px;
}

.div_004_001 > div:last-child > div:nth-child(2) > span:nth-child(2){
    width: 90px;
}

.div_004_001 > div:nth-child(2) > div > span:last-child ,
.div_004_001 > div:last-child   > div > span:last-child {
    width: 100%;

    font-size: 10px;
    
    margin-top: 10px;
}

/*** ************************************************* ***/

.div_005 {
    width: 100%;
    height: 1196px;
    
    background-color: #F7F4EC;
}

.div_005_001 {
    width: 1376px;
    height: 104px;
    
    margin: 64px auto 0px;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : flex-start;
}

.div_005_001 > div:first-child {
    width: 50%;
    height: 104px;
    
    font-size: 36px;
    font-weight: 600;
    
    text-align: left;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_005_001 > div:last-child {
    width: 50%;
    
    font-size: 20px;
    
    text-align: right;
}

.div_005_002 {
    width: 1376px;
    height: 932px;
    
    margin: 32px auto 0px;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_005_002_l {
    width: 868px;
    height: 95%;
    
    background-image : url('../assets/02 Features/image_001.svg');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
    
    position: relative;
}

.div_005_002_l > div {
    width: 148px;
    height: 54px;
    
    color: #7D7D7D;
    background-color: #D9D9D9;
    
    cursor: pointer;
    
    border-radius: 8px;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
}

.div_005_002_l_active {
    color: #2F2F2F !important;
    background-color: #E1B94F !important;
}

.div_005_002_l > div:first-child {
    position: absolute;
    top: 3px;
    left: 0px;
}

.div_005_002_l > div:nth-child(2) {
    position: absolute;
    top: 55px;
    left: 412px;
}

.div_005_002_l > div:nth-child(3) {
    position: absolute;
    top: 157px;
    left: 717px;
}

.div_005_002_l > div:nth-child(4) {
    position: absolute;
    top: 416px;
    left: 715px;
}

.div_005_002_l > div:nth-child(5) {
    position: absolute;
    top: 422px;
    left: 211px;
}

.div_005_002_l > div:last-child {
    position: absolute;
    top: 595px;
    left: 120px;
}

.div_005_002_r {
    width: 460px;
    height: 100%;
    
    display : flex;
    flex-direction : column;
    justify-content : space-between;
    align-items : center;
}

.div_005_002_r > div {
    width: 460px;
    
    border-radius: 8px;
    
    cursor: pointer;
    
    color: #7D7D7D;
    background-color: #D9D9D9;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

.div_005_002_r_active {
    color: #E1B94F !important;
    background-color: #151513 !important;
}

.div_005_002_r > div:first-child {
    height: 144px;
}

.div_005_002_r > div:nth-child(2) {
    height: 100px;
}

.div_005_002_r > div:nth-child(3) {
    height: 144px;
}

.div_005_002_r > div:nth-child(4) {
    height: 120px;
}

.div_005_002_r > div:nth-child(5) {
    height: 120px;
}

.div_005_002_r > div:last-child {
    height: 144px;
}

.div_005_002_r > div > div:first-child {
    width: 21px;
    height: 52px;
    
    font-size: 36px;
    
    margin: 0px 24px;
}

.div_005_002_r > div > div:nth-child(2) {
    width: 3px;
    height: 36px;
    
    border-radius: 2px;
    
    background-color: #D9D9D9;
}

.div_005_002_r > div > div:last-child {
    width: 359px;
    
    font-size: 16px;
    
    text-align: justify;
    
    margin-left: 16px;
}

/*** ************************************************* ***/
/*** ************************************************* ***/

.div_mobile_001 {
    width: 100%;
    height: 88px;
    
    background-color: #151513;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
    
    position: fixed;
    top: 0px;
    
    z-index: 9999999;
}

.div_mobile_001_001 {
    width: 90%;
    height: 100%;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_mobile_001_001_l {
    width: 137px;
    height: 32px;
    
    background-image : url('../assets/image_000_001.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_mobile_001_001_r {
    width: 40px;
    height: 40px;
    
    background-color: #F7F4EC;
    
    border-radius: 4px;
        
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
}

.div_mobile_001_001_r > div {
    width: 28px;
    height: 3px;
    
    margin-top: 2.5px;
    margin-bottom: 2.5px;
    
    border-radius: 2px;
    
    background-color: #151513;
}

.div_mobile_menu {
    width: 100%;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
    
    position: fixed;
    left: 0px;
    
    z-index: 999999;
}

.div_mobile_menu > div {
    width: 100%;
    height: 70px;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
    
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    
    background-color: #F7F4EC;
}

.div_mobile_menu > div:first-child {
    margin-top: 88px;
}

.div_mobile_menu > div:last-child {
    width: 100%;
    
    background-color: rgba(0, 0, 0, 0);
}

/*** ************************************************* ***/

.div_mobile_002 {
    width: 100%;
    height: 168px;
    
    color: #F7F4EC;
    background-color: #151513;
}

.div_mobile_002_001 {
    width: 90%;
    height: 100%;
    
    margin: 0 auto;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : flex-start;
}

.div_mobile_002_001 > div:first-child {
    width: 24px;
    height: 24px;
    
    margin-top: 120px;
    
    cursor: pointer;
    
    background-image : url('../assets/image_000_005.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_mobile_002_001 > div:nth-child(2) {
    width: 24px;
    height: 24px;
    
    margin-top: 120px;
    margin-left: 22px;
    
    cursor: pointer;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

.div_mobile_002_001 > div:nth-child(2) > div {
    width : 0px;
    height: 0px;
    
    border-top : 8px solid transparent;
    border-left : 8px solid #F7F4EC;
    border-right : 8px solid transparent;
    border-bottom : 8px solid transparent;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
    
    position: relative;
}

.div_mobile_002_001 > div:nth-child(2) > div > div {
    width : 0px;
    height: 0px;
    
    border-top : 5px solid transparent;
    border-left : 5px solid #151513;
    border-right : 5px solid transparent;
    border-bottom : 5px solid transparent;
    
    position: absolute;
    left: -8px;
}

.div_mobile_002_001 > div:last-child {
    width : 200px;
    height: 24px;
    
    font-size: 16px;
    
    margin-top: 120px;
    margin-left: 5px;
    
    cursor: pointer;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

/*** ************************************************* ***/

.div_mobile_003 {
    width: 100%;
    height: 520px;
    background-color: #151513;
}

.div_mobile_003_001 {
    width: 100%;
    height: 100%;
    
    margin: 0 auto;
}

.div_mobile_003_001 > div {
    width: 90%;
    height: 500px;
    
    margin: 0 auto;
    border-radius: 10px;
    
    background-image : url('../assets/02 Features/cover.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 200%;
    
    position: relative;
}

.div_mobile_003_001_l {
    width : 250px;
    height: 100px;
    
    color: #2F2F2F;
    font-size: 16px;
    font-weight: 500;
    
    color: #F7F4EC;
    background-color: #151513;
    
    clip-path: polygon(0 0, 0 100%, 100% 100%);
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : flex-end;
    
    position: absolute;
    bottom: 0;
    left: 0;
}

.div_mobile_003_001_l > div {
    width : 24px;
    height: 24px;
    
    cursor: pointer;
    
    background-image : url('../assets/image_000_006.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_mobile_003_001_l > span {
    margin-left: 12px;
    margin-bottom: 2.5px;
    cursor: pointer;
}

.div_mobile_003_001_r {
    width : 300px;
    height: 60px;
    
    position: absolute;
    bottom: 120px;
    right: 10px;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : flex-end;
}

.div_mobile_003_001_r > div:first-child {
    width: 300px;
    
    font-size: 12px;
    color: #F7F4EC;
    
    margin-top: 18px;
    
    display : flex;
    flex-direction : row;
    justify-content : space-around;
    align-items : center;
}

.div_mobile_003_001_r > div:last-child {
    font-size: 20px;
    color: #E1B94F;
    font-weight: 600;
    
    margin-top: 18px;
}

/*** ************************************************* ***/

.div_mobile_004 {
    width: 100%;
    
    background-color: #151513;
}

.div_mobile_004_001 {
    width: 90%;
    height: 100%;
    
    margin: 0px auto;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
    
    padding-bottom: 30px;
}

.div_mobile_004_001 > div:first-child {
    width: 90%;
    height: 80px;
    
    margin-top: 40px;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_mobile_004_001 > div:first-child > div:first-child {
    width: 30px;
    height: 40px;
    
    color: #3F3A3A;
    font-size: 20px;
    font-weight: 600;
    background-color: #E9B733;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
}

.div_mobile_004_001 > div:first-child > div:nth-child(2) {
    width: 90%;
    
    font-size: 12px;
    color: #F7F4EC;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : flex-start;
}

.div_mobile_004_001 > div:first-child > div:nth-child(2) > span {
    margin-left: 16px;
}

.div_mobile_004_001 > div:first-child > div:last-child {
    width : 0px;
    height: 0px;
    
    border-top : 20px solid #E9B733;
    border-left : 20px solid transparent;
    border-right : 20px solid #E9B733;
    border-bottom : 20px solid transparent;
}

.div_mobile_004_001 > div:nth-child(2),
.div_mobile_004_001 > div:last-child {
    width: 90%;
    
    display : flex;
    flex-direction : row;
    justify-content : space-around;
    align-items : center;
    
    flex-wrap: wrap;
}

.div_mobile_004_001 > div:nth-child(2) > div,
.div_mobile_004_001 > div:last-child   > div {
    width: 140px;
    height: 140px;
    
    margin-top: 20px;
    
    color: #151513;
    background-color: #F7F4EC;
    
    border-radius: 16px;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

.div_mobile_004_001 > div:nth-child(2) > div > div:first-child ,
.div_mobile_004_001 > div:last-child   > div > div:first-child {
    width: 40px;
    height: 48px;
    
    margin-top: 15px;
    
    cursor: pointer;
    
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.icon_001 { background-image : url('../assets/02 Features/icon_001.svg'); }
.icon_002 { background-image : url('../assets/02 Features/icon_002.svg'); }
.icon_003 { background-image : url('../assets/02 Features/icon_003.svg'); }
.icon_004 { background-image : url('../assets/02 Features/icon_004.svg'); }
.icon_005 { background-image : url('../assets/02 Features/icon_005.svg'); }
.icon_006 { background-image : url('../assets/02 Features/icon_006.svg'); }
.icon_007 { background-image : url('../assets/02 Features/icon_007.svg'); }
.icon_008 { background-image : url('../assets/02 Features/icon_008.svg'); }
.icon_009 { background-image : url('../assets/02 Features/icon_009.svg'); }
.icon_010 { background-image : url('../assets/02 Features/icon_010.svg'); }

.div_mobile_004_001 > div:nth-child(2) > div > span:nth-child(2) ,
.div_mobile_004_001 > div:last-child   > div > span:nth-child(2) {
    width: 120px;
    height: 48px;
    
    font-size: 12px;
    
    display : flex;
    flex-direction : column;
    justify-content : space-around;
    align-items : center;
}

.div_mobile_004_001 > div:nth-child(2) > div > span:last-child ,
.div_mobile_004_001 > div:last-child   > div > span:last-child {
    width: 100%;
    
    font-size: 9px;
    
    margin-top: 0px;
}

/*** ************************************************* ***/

.div_mobile_005 {
    width: 100%;
    
    background-color: #F7F4EC;
}

.div_mobile_005_001 {
    width: 90%;
    height: 104px;
    
    margin: 30px auto 0px;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : flex-start;
}

.div_mobile_005_001 > div:first-child {
    width: 100%;
    height: 104px;
    
    font-size: 20px;
    font-weight: 600;
    
    text-align: left;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_mobile_005_001 > div:last-child {
    width: 100%;
    
    font-size: 10px;
    
    text-align: right;
    
    padding-top: 17px;
}

.div_mobile_005_002 {
    width: 90%;
    
    margin: 32px auto 0px;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

.div_mobile_005_002_l {
    width: 300px;
    height: 300px;
    
    background-image : url('../assets/02 Features/image_001.svg');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
    
    position: relative;
}

.div_mobile_005_002_l > div {
    width: 62px;
    height: 22px;
    
    color: #7D7D7D;
    background-color: #D9D9D9;
    
    font-size: 10px;
    font-weight: 600;
    
    border-radius: 2px;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
}

.div_mobile_005_002_l_active {
    color: #2F2F2F !important;
    background-color: #E1B94F !important;
}

.div_mobile_005_002_l > div:first-child {
    width: 56px;
    
    position: absolute;
    top: 41px;
    left: 0px;
}

.div_mobile_005_002_l > div:nth-child(2) {
    width: 50px;
    
    position: absolute;
    top: 12px;
    left: 143px;
}

.div_mobile_005_002_l > div:nth-child(3) {
    width: 68px;
    
    position: absolute;
    top: 47px;
    left: 233px;
}

.div_mobile_005_002_l > div:nth-child(4) {
    width: 69px;
    
    position: absolute;
    top: 184px;
    left: 230px;
}

.div_mobile_005_002_l > div:nth-child(5) {
    width: 54px;
    
    position: absolute;
    top: 139px;
    left: 73px;
}

.div_mobile_005_002_l > div:last-child {
    width: 56px;
    
    position: absolute;
    top: 246px;
    left: 40px;
}

.div_mobile_005_002_r {
    width: 90%;
    height: 100%;
    
    display : flex;
    flex-direction : column;
    justify-content : space-between;
    align-items : center;
}

.div_mobile_005_002_r > div {
    width: 100%;
    
    border-radius: 8px;
    
    margin: 10px;
    
    color: #7D7D7D;
    background-color: #D9D9D9;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

.div_mobile_005_002_r_active {
    color: #E1B94F !important;
    background-color: #151513 !important;
}

.div_mobile_005_002_r > div:first-child {
    height: 100px;
}

.div_mobile_005_002_r > div:nth-child(2) {
    height: 100px;
}

.div_mobile_005_002_r > div:nth-child(3) {
    height: 110px;
}

.div_mobile_005_002_r > div:nth-child(4) {
    height: 110px;
}

.div_mobile_005_002_r > div:nth-child(5) {
    height: 110px;
}

.div_mobile_005_002_r > div:last-child {
    height: 110px;
    margin-bottom: 30px;
}

.div_mobile_005_002_r > div > div:first-child {
    width: 10px;
    height: 52px;
    
    font-size: 22px;
    margin: 0px 8px 0px 15px;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
}

.div_mobile_005_002_r > div > div:nth-child(2) {
    width: 3px;
    height: 20px;
    
    border-radius: 2px;
    
    background-color: #D9D9D9;
}

.div_mobile_005_002_r > div > div:last-child {
    width: 80%;
    
    font-size: 12px;
    
    text-align: justify;
    
    margin-left: 8px;
}

/*** ************************************************* ***/
</style>